import { Inject } from 'vue-di-container';
import { Component, ProvideReactive, Vue } from 'vue-property-decorator';
import WithRender from './app.html';
// Components
import BreadCrumb from '@/modules/shared/components/breadcrumb/breadcrumb';
import { getThemeColor } from './appTheme';
// Services
import UserService from '@/modules/shared/services/userService';
// Models
import { UserModel } from '@/modules/shared/models/user';

@WithRender
@Component({
  components: {
    BreadCrumb,
  },
  diProvide: [
    UserService,
  ],
})
export default class App extends Vue {
  @Inject(UserService)
  private userService!: UserService;

  @ProvideReactive()
  private userInfo: UserModel = {} as UserModel;

  @ProvideReactive()
  private isUserInfoLoading = true;

  created() {
    this.updateUIFrameWork();
    this.getUserInfo();
  }

  getUserInfo() {
    this.userService.getUser()
      .then((userInfo) => this.userInfo = userInfo)
      .finally(() => this.isUserInfoLoading = false);
  }

  public updateUIFrameWork() {
    const { primary, secondary } = this.$vuetify.theme.themes.light;

    const lightTheme = this.$vuetify.theme.themes.light;
    lightTheme.primary = getThemeColor('dark') || primary;
    lightTheme.secondary = getThemeColor('secondary') || secondary;
  }
}
